import { OnlineOrdering, MarketToCustomers } from "@slfinrtl/ui-bff-routes"
import { useMemo } from "react"
import { useIntl } from "react-intl"
import { commonMessages } from "src/common/messages/common.messages"
import { useConfig } from "src/hooks"
import type { VisibilityFields } from "../components"
import { visibilityFieldMessages, visibilityFieldNames } from "../components"

export const useVisibilityFields = (): VisibilityFields => {
	const { formatMessage } = useIntl()

	const { carSalesLiteEnabled, onlineOrderingEnabled } = useConfig()

	const fields = useMemo((): VisibilityFields => {
		return {
			marketToCustomers: {
				disabledHint: carSalesLiteEnabled
					? formatMessage(commonMessages.notAvailableInCarsalesLite)
					: undefined,
				label: formatMessage(visibilityFieldMessages.marketToCustomersLabel),
				name: visibilityFieldNames.marketToCustomersName,
				options: [
					{
						label: formatMessage(visibilityFieldMessages.marketToCustomersDisabled),
						message: formatMessage(visibilityFieldMessages.marketToCustomersDisabledDescription),
						value: MarketToCustomers.HIDDEN,
					},
					{
						label: formatMessage(visibilityFieldMessages.marketToCustomersEnabled),
						message: formatMessage(visibilityFieldMessages.marketToCustomersEnabledDescription),
						value: MarketToCustomers.VISIBLE,
					},
				],
				required: !carSalesLiteEnabled,
				withoutPreselection: true,
			},
			onlineOrdering:
				onlineOrderingEnabled && !carSalesLiteEnabled
					? {
							label: formatMessage(visibilityFieldMessages.onlineOrderingEnabledLabel),
							name: visibilityFieldNames.onlineOrderingName,
							options: [
								{
									label: formatMessage(visibilityFieldMessages.onlineOrderingDisabled),
									value: OnlineOrdering.DISABLED,
								},
								{
									label: formatMessage(visibilityFieldMessages.onlineOrderingEnabled),
									value: OnlineOrdering.ENABLED,
								},
							],
							required: true,
							withoutPreselection: true,
						}
					: undefined,
		}
	}, [formatMessage, onlineOrderingEnabled, carSalesLiteEnabled])

	return fields
}
